const getToastsState = state => state.toasts

export const getMessages = state => getToastsState(state).messages



// WEBPACK FOOTER //
// ./web/js/toasts/selectors.js